import { Download } from "lucide-react";
import { useState } from "react";

export default function ImageWithTransition({ src, onDownload }) {
    const [loaded, setLoaded] = useState(false);
  
    return (
      <div className="relative w-[360px] h-[400px] rounded-xl overflow-hidden bg-neutral-200">
        {/* Base skeleton */}
        {!loaded && (
          <div className="absolute inset-0 bg-neutral-300 animate-pulse" />
        )}
  
        {/* FLASH SHIMMER */}
        {!loaded && (
          <div className="absolute inset-0 shimmer-mask pointer-events-none" />
        )}
  
        {/* Image */}
        <img
          src={src}
          alt="Generated"
          onLoad={() => setLoaded(true)}
          className={`
            w-full h-full object-cover
            transition-[opacity,filter,transform]
            duration-700 ease-out
            ${loaded
              ? "opacity-100 blur-0 scale-100"
              : "opacity-0 blur-md scale-[1.02]"
            }
          `}
        />
  
        {/* Download */}
        {loaded && (
          <button
            onClick={onDownload}
            className="absolute top-3 right-3 bg-white/80 backdrop-blur rounded-full p-2 shadow-md"
          >
            <Download className="w-5 h-5" />
          </button>
        )}
      </div>
    );
  }